import { render, staticRenderFns } from "./detallePagoComponent.vue?vue&type=template&id=452372aa&scoped=true"
import script from "./detallePagoComponent.vue?vue&type=script&lang=js"
export * from "./detallePagoComponent.vue?vue&type=script&lang=js"
import style0 from "./detallePagoComponent.vue?vue&type=style&index=0&id=452372aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452372aa",
  null
  
)

export default component.exports